/*
 * Bobby Rubber Stamp — "Shop by category" drag-to-scroll row.
 *
 * The row is a native horizontal scroller (overflow-x:auto), so touch devices
 * already get momentum scrolling for free. This adds click-drag-to-scroll for
 * the mouse: hold the left button and pull the row sideways. Move/up are bound
 * on window for the duration of the drag (rather than pointer capture, which
 * can drop events) so the pull keeps tracking even off the row. A drag past a
 * small threshold suppresses the trailing click so pulling never accidentally
 * opens a category.
 *
 * Idempotent; re-inits on shopify:section:load for the theme editor.
 */
(function () {
  function initRow(row) {
    if (!row || row.dataset.dragInit === 'true') return;
    row.dataset.dragInit = 'true';

    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var moved = 0;

    function onMove(e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      row.scrollLeft = startScroll - dx;
    }

    function onUp() {
      if (!isDown) return;
      isDown = false;
      row.classList.remove('is-dragging');
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
      window.removeEventListener('pointercancel', onUp);
    }

    row.addEventListener('pointerdown', function (e) {
      // Mouse only — let touch/pen use the browser's native scrolling.
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (e.button !== 0) return;
      isDown = true;
      moved = 0;
      startX = e.clientX;
      startScroll = row.scrollLeft;
      row.classList.add('is-dragging');
      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerup', onUp);
      window.addEventListener('pointercancel', onUp);
    });

    // If the pointer actually dragged, swallow the click that follows so the
    // card link doesn't fire. Capture phase so it beats the anchor's own click.
    row.addEventListener(
      'click',
      function (e) {
        if (moved > 6) {
          e.preventDefault();
          e.stopPropagation();
          moved = 0;
        }
      },
      true
    );

    // Stop the browser's native image/link ghost-drag.
    row.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
  }

  function boot() {
    document.querySelectorAll('[data-cat-row]').forEach(initRow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var row = e.target.querySelector ? e.target.querySelector('[data-cat-row]') : null;
    if (row) initRow(row);
  });
})();
